import { reactive } from 'vue'

interface SwitchKeySyncDialogState {
  visible: boolean
  resolve: ((value: boolean) => void) | null
}

const switchKeySyncDialogState = reactive<SwitchKeySyncDialogState>({
  visible: false,
  resolve: null,
})

/**
 * 弹出切换键同步确认弹窗（可视化版本，替代纯文字 enableDialog）
 * @returns true = 用户选择同步，false = 用户选择跳过
 */
const showSwitchKeySyncDialog = (): Promise<boolean> => {
  return new Promise((resolve) => {
    // 如果已经有一个等待中的弹窗，先 resolve 掉
    if (switchKeySyncDialogState.resolve) {
      switchKeySyncDialogState.resolve(false)
    }
    switchKeySyncDialogState.visible = true
    switchKeySyncDialogState.resolve = resolve
  })
}

const closeSwitchKeySyncDialog = (value: boolean) => {
  if (switchKeySyncDialogState.resolve) {
    switchKeySyncDialogState.resolve(value)
    switchKeySyncDialogState.resolve = null
  }
  switchKeySyncDialogState.visible = false
}

export { switchKeySyncDialogState, showSwitchKeySyncDialog, closeSwitchKeySyncDialog }
